import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface ActivityFilterValue {
  selectedUsers: any[];
  startDate: any;
  endDate: any;
}

@Component({
  selector: 'app-activity-filter-form',
  templateUrl: './activity-filter-form.component.html',
  styleUrls: ['./activity-filter-form.component.scss']
})
export class ActivityFilterFormComponent implements OnInit {
  @Input() usersList: any[] = [];
  @Input() minDate: Date = new Date(2020, 7, 31);
  @Input() maxDate: Date = new Date();

  @Output() search = new EventEmitter<ActivityFilterValue>();
  @Output() reset = new EventEmitter<void>();
  @Output() export = new EventEmitter<ActivityFilterValue>();

  filterForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.filterForm = this.fb.group(
      {
        selectedUser: [[], [Validators.required]],
        startDate: ['', [Validators.required]],
        endDate: ['', [Validators.required]],
      },
      this.checkDates.bind(this)
    ) as FormGroup;
  }

  checkDates(group: FormGroup): any {
    if (group.controls['endDate'].value < group.controls['startDate'].value) {
      return { notValid: true };
    }
    return null;
  }

  onSearch(): void {
    this.markAllTouched();
    if (this.filterForm.valid) {
      this.search.emit(this.getFilterValue());
    }
  }

  onReset(): void {
    this.filterForm.reset();
    this.filterForm.patchValue({ selectedUser: [] });
    this.reset.emit();
  }

  onExport(): void {
    this.markAllTouched();
    if (this.filterForm.valid) {
      this.export.emit(this.getFilterValue());
    }
  }

  onUserSelectionChange(selectedUsers: any[]): void {
    this.filterForm.patchValue({ selectedUser: selectedUsers });
  }

  getStartDateValue(): any {
    const ctrl = this.filterForm.get('startDate');
    return ctrl ? ctrl.value : null;
  }

  private getFilterValue(): ActivityFilterValue {
    const selectedUserCtrl = this.filterForm.get('selectedUser');
    const startDateCtrl = this.filterForm.get('startDate');
    const endDateCtrl = this.filterForm.get('endDate');
    return {
      selectedUsers: selectedUserCtrl ? selectedUserCtrl.value || [] : [],
      startDate: startDateCtrl ? startDateCtrl.value : null,
      endDate: endDateCtrl ? endDateCtrl.value : null,
    };
  }

  private markAllTouched(): void {
    Object.keys(this.filterForm.controls).forEach(key => {
      const control = this.filterForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }
}
